import * as $p5js_gleam from "../p5js_gleam/p5js_gleam.mjs";
import * as $p5 from "../p5js_gleam/p5js_gleam/bindings.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";
import * as $vector from "./vector.mjs";

/**
 * Represents an obstacle that the player must avoid.
 */
export class Obstacle extends $CustomType {
  constructor(position) {
    super();
    this.position = position;
  }
}
export const Obstacle$Obstacle = (position) => new Obstacle(position);
export const Obstacle$isObstacle = (value) => value instanceof Obstacle;
export const Obstacle$Obstacle$position = (value) => value.position;
export const Obstacle$Obstacle$0 = (value) => value.position;

export const size = 6.0;

export const damage = 10;

/**
 * Checks if the object at the given position with given radius collides with the bullet.
 */
export function collides_with(obstacle, position, object_size) {
  return $vector.distance(obstacle.position, position) < ((size / 2.0) + (object_size / 2.0));
}

/**
 * Renders the obstacle to the screen
 */
export function draw(p, obstacle) {
  let position = obstacle.position;
  let spike1 = 4.0;
  let spike2 = 5.0;
  let _pipe = $p5.stroke(p, "#f4424b");
  let _pipe$1 = $p5.fill(_pipe, "#f4424b");
  let _pipe$2 = $p5.circle(_pipe$1, position.x, position.y, size);
  let _pipe$3 = $p5.line(
    _pipe$2,
    position.x - spike1,
    position.y - spike1,
    position.x + spike1,
    position.y + spike1,
  );
  let _pipe$4 = $p5.line(
    _pipe$3,
    position.x - spike1,
    position.y + spike1,
    position.x + spike1,
    position.y - spike1,
  );
  let _pipe$5 = $p5.line(
    _pipe$4,
    position.x,
    position.y - spike2,
    position.x,
    position.y + spike2,
  );
  return $p5.line(
    _pipe$5,
    position.x - spike2,
    position.y,
    position.x + spike2,
    position.y,
  );
}
